import { render, staticRenderFns } from "./failureReason.vue?vue&type=template&id=84b1627a&scoped=true"
import script from "./failureReason.vue?vue&type=script&lang=js"
export * from "./failureReason.vue?vue&type=script&lang=js"
import style0 from "./failureReason.vue?vue&type=style&index=0&id=84b1627a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b1627a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\crmeb\\gitcode\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84b1627a')) {
      api.createRecord('84b1627a', component.options)
    } else {
      api.reload('84b1627a', component.options)
    }
    module.hot.accept("./failureReason.vue?vue&type=template&id=84b1627a&scoped=true", function () {
      api.rerender('84b1627a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/failureReason.vue"
export default component.exports